<template>
	<ApiErrorCard v-if="apiError" :error="apiError" />
	<ul v-else-if="loanApplications.length > 0" class="space-y-2">
		<li v-for="loanApplication in loanApplications" :key="loanApplication.id">
			<RouterLink
				class="block"
				:to="
					useLoanApplicationLink(Number(dossier.displayId), loanApplication.id)
				"
			>
				<LoanApplicationListItem>
					<div class="flex gap-2 items-center">
						<img
							v-if="
								getLenderOption(
									loanApplication.hdnDossier?.providerCode ?? undefined,
								)?.icon
							"
							class="w-8 h-8 object-contain"
							:src="`/logos/${getLenderOption(loanApplication.hdnDossier?.providerCode ?? undefined)?.icon}`"
						/>
						<span>
							{{
								loanApplication.hdnDossier?.provider?.label ??
								splitHdnValue(
									loanApplication.hdnDossier?.provider?.name ?? "",
								)[1]
							}}
						</span>
					</div>
					<div class="flex gap-2 items-center">
						<AppTag>
							{{
								!loanApplication.hdnDossier?.status ||
								loanApplication.hdnDossier.status === "draft"
									? "Concept"
									: splitHdnValue(loanApplication.hdnDossier.status)[1]
							}}
						</AppTag>
						<span class="text-sm text-gray-500">
							{{ formatDate(loanApplication.createdAt) }}
						</span>
					</div>
				</LoanApplicationListItem>
			</RouterLink>
			<IvoProviderWarning
				class="mt-2"
				:receiver-code="loanApplication.hdnDossier?.receiverCode"
				:nhg="nhg"
				:has-onderneming="hasOnderneming"
				:has-ivo="hasIvo"
			/>
		</li>
	</ul>
	<span v-else class="text-gray-500 pt-8 text-center w-full block">
		Geen offerteaanvragen gevonden
	</span>
</template>

<script lang="ts" setup>
import { useProviderLenders } from "@/composables/useProviderLenders";
import { useIvoDossierContext } from "@/composables/useIvoDossierContext";
import { useLoanApplicationLink } from "@/composables/useRouterLinks";
import { splitHdnValue } from "@/helpers/hdnHelpers";
import type { ApiError } from "@/models/ApiError";
import { computed, ref } from "vue";
import { formatDate } from "@/helpers/uiHelpers";
import type { Row } from "@rocicorp/zero";
import { useQuery } from "@/composables/useZero";
import { queries } from "@loanlink-nl/zero";
import IvoProviderWarning from "@/components/ivo/IvoProviderWarning.vue";

const props = defineProps<{
	dossier: Row["dossier"];
}>();

const { data: loanApplications } = useQuery(() =>
	queries.loanApplications.forDossier({
		dossierId: props.dossier.id ?? "",
		orderField: "createdAt",
		order: "desc",
	}),
);

const { getLenderOption } = useProviderLenders();
const {
	hasOnderneming: dossierHasOnderneming,
	hasIvo: dossierHasIvo,
	nhg: dossierNhg,
} = useIvoDossierContext();
const hasOnderneming = computed(() => dossierHasOnderneming.value);
const hasIvo = computed(() => dossierHasIvo.value);
const nhg = computed(() => {
	return dossierNhg.value;
});

const apiError = ref<ApiError | null>(null);
</script>
